/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Sug_CallInputs */

const en_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a call?`)
};

const ar_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجز مكالمة؟`)
};

const bn_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কল বুক করব কীভাবে?`)
};

const de_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Anruf buchen?`)
};

const es_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Reservar una llamada?`)
};

const fr_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réserver un appel ?`)
};

const pt_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agendar uma ligação?`)
};

const zh_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预约电话？`)
};

const tr_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arama ayarlamak ister misiniz?`)
};

const ru_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказать звонок?`)
};

const pl_chat_sug_call = /** @type {(inputs: Chat_Sug_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwować połączenie?`)
};

/**
* | output |
* | --- |
* | "Book a call?" |
*
* @param {Chat_Sug_CallInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_sug_call = /** @type {((inputs?: Chat_Sug_CallInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Sug_CallInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_sug_call(inputs)
	if (locale === "bn") return bn_chat_sug_call(inputs)
	if (locale === "de") return de_chat_sug_call(inputs)
	if (locale === "es") return es_chat_sug_call(inputs)
	if (locale === "fr") return fr_chat_sug_call(inputs)
	if (locale === "pt") return pt_chat_sug_call(inputs)
	if (locale === "zh") return zh_chat_sug_call(inputs)
	if (locale === "tr") return tr_chat_sug_call(inputs)
	if (locale === "ru") return ru_chat_sug_call(inputs)
	if (locale === "pl") return pl_chat_sug_call(inputs)
	return en_chat_sug_call(inputs)
});